import { IS_LOCAL } from '@/helpers';
import i18n from '@/plugins/i18n';

/**
 * @description 에러 모달 오픈
 */
function openErrModal(errModal, e) {
  console.error(e);

  errModal.open({
    // 오류가 발생했습니다.
    title: e.response?.data?.message?.title ?? i18n.t('etc.modalerr'),
    content: e.response?.data?.message?.content ?? e.response?.data?.message?.replaceAll('|', '<br />') ?? e,
    cancel: false,
  });
}

const SpringStore = {
  namespaced: true,
  state() {
    return {
      // 꽃 및 물주기 상태
      flowerStatus: {},
      // 모은 꽃 개수 및 상태
      flowerRewardStatus: {},
      // 미션 상태
      missionStatus: {},
      // 미션 상세
      missionDetail: [],
      // 꽃 맟추기 상태
      flowerMatchStatus: {},
      // 꽃 맞히기 기록
      flowerMatchRecord: [],
    };
  },
  mutations: {
    // 꽃 및 물주기 상태 설정
    setFlowerStatus(state, data) {
      state.flowerStatus = data;
    },
    // 모은 꽃 개수 및 상태 설정
    setFlowerRewardStatus(state, data) {
      state.flowerRewardStatus = data;
    },
    // 미션 상태 설정
    setMissionStatus(state, data) {
      state.missionStatus = data;
    },
    // 미션 상세 설정
    setMissionDetail(state, data) {
      state.missionDetail = data;
    },
    // 꽃 맟추기 상태 설정
    setFlowerMatchStatus(state, data) {
      state.flowerMatchStatus = data;
    },
    // 꽃 맞히기 기록 설정
    setFlowerMatchRecord(state, data) {
      state.flowerMatchRecord = data;
    },
  },
  actions: {
    /**
     * @description API 호출
     */
    async fetch({ rootState: { vm, globalErrorModal } }, { url, method, params }) {
      const data = method === 'get' ? { params: { ...params } } : params;

      try {
        const { data: responseData } = await this._vm.$axios[method](
          `${process.env.VUE_APP_TEST_SERVER}${'/flower' + url}`,
          data
        );
        return responseData;
      } catch (e) {
        if (e?.response?.status === 401) vm.$bvModal.show('login-required');
        else openErrModal(globalErrorModal, e);

        throw e;
      }
    },
    /**
     * @description 꽃 및 물주기 상태 조회
     */
    async getFlowerStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          flower: {
            // 개나리
            gnl: {
              count: 0,
              isComplete: true,
              isReceive: false,
            },
            // 진달래
            jdl: {
              count: 10,
              isComplete: true,
              isReceive: false,
            },
            // 설광화
            sgh: {
              count: 12,
              isComplete: true,
              isReceive: false,
            },
            // 제비꽃
            jbg: {
              count: 0,
              isComplete: true,
              isReceive: false,
            },
            // 노루귀꽃
            nlgg: {
              count: 3,
              isComplete: false,
              isReceive: false,
            },
            // 유채꽃
            ycg: {
              count: 0,
              isComplete: false,
              isReceive: false,
            },
            // 벛꽃
            bg: {
              count: 5,
              isComplete: false,
              isReceive: false,
            },
            // 라일락
            lil: {
              count: 0,
              isComplete: false,
              isReceive: false,
            },
            // 수선화
            ssh: {
              count: 0,
              isComplete: false,
              isReceive: false,
            },
          },
          opportunity: 10, // 물뿌리개
          isCloverPurchased: false, // 오늘 클로버 구매했는지 여부
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/event1/status',
      });

      return response;
    },
    /**
     * @description 꽃 및 물주기
     */
    async fetchFlowerStatus({ dispatch, commit }) {
      console.log('fetchFlowerStatus');
      const flowerStatus = await dispatch('getFlowerStatus');

      commit('setFlowerStatus', flowerStatus);
      return;
    },
    /**
     * @description 모은 꽃 개수 및 상태 조회
     */
    async getFlowerRewardStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          count: 9,
          isComplete: true,
          isReceive: false,
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/event1/total/status',
      });

      return response;
    },
    /**
     * @description 모은 꽃 개수 및 상태 조회
     */
    async fetchFlowerRewardStatus({ dispatch, commit }) {
      console.log('fetchFlowerRewardStatus');
      const flowerReward = await dispatch('getFlowerRewardStatus');

      commit('setFlowerRewardStatus', flowerReward);
      return;
    },
    /**
     * @description 미션 상태 조회
     */
    async getMissionStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          invite: 0,
          subs: 0,
          rentalIncome: 0,
          lucky: 1,
          swap: 1,
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/event1/mission',
      });

      return response;
    },
    /**
     * @description 미션 상태 조회
     */
    async fetchMissionStatus({ dispatch, commit }) {
      console.log('fetchMissionStatus');
      const missionStatus = await dispatch('getMissionStatus');

      commit('setMissionStatus', missionStatus);
      return;
    },
    /**
     * @description 미션 상세 조회
     */
    async getMissionDetail({ dispatch }) {
      if (IS_LOCAL) {
        return [
          {
            date: '2024-03-22T17:34:23',
            content: '출석체크 완료',
            value: 1,
          },
        ];
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/event1/mission/detail',
      });

      return response;
    },
    /**
     * @description 미션 상세 조회
     */
    async fetchMissionDetail({ dispatch, commit }) {
      console.log('fetchMissionDetail');
      const missionDetail = await dispatch('getMissionDetail');

      commit('setMissionDetail', missionDetail);
      return;
    },
    /**
     * @description 물주기
     */
    async postWatering({ dispatch }, { flower }) {
      if (IS_LOCAL) {
        return 50;
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/event1/watering',
        params: {
          flower: flower,
        },
      });

      return response;
    },
    /**
     * @description 물주기
     */
    async submitWatering({ dispatch }, { flower }) {
      console.log('submitWatering');
      const result = await dispatch('postWatering', { flower });

      return result;
    },
    /**
     * @description 모은 꽃 보상 수령
     */
    async postFlowerReward({ dispatch }) {
      if (IS_LOCAL) {
        return '';
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/event1/total/reward',
      });

      return response;
    },
    /**
     * @description 모은 꽃 보상 수령
     */
    async submitFlowerReward({ dispatch }) {
      console.log('submitFlowerReward');
      const result = await dispatch('postFlowerReward');

      return result;
    },
    /**
     * @description 개별 꽃 보상 수령
     */
    async postSingleFlowerReward({ dispatch }, { flower }) {
      if (IS_LOCAL) {
        return '';
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/event1/flower/reward',
        params: {
          flower: flower,
        },
      });

      return response;
    },
    /**
     * @description 개별 꽃 보상 수령
     */
    async submitSingleFlowerReward({ dispatch }, { flower }) {
      console.log('submitSingleFlowerReward');
      const result = await dispatch('postSingleFlowerReward', { flower });

      return result;
    },
    /**
     * @description 물주기 횟수 구매
     */
    async postPurchaseKettle({ dispatch }) {
      if (IS_LOCAL) {
        return '';
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/event1/buy/opportunity',
      });

      return response;
    },
    /**
     * @description 물주기 횟수 구매
     */
    async submitPurchaseKettle({ dispatch }) {
      console.log('submitPurchaseKettle');
      const result = await dispatch('postPurchaseKettle');

      return result;
    },
    /**
     * @description 꽃 맞히기 상태 조회
     */
    async getFlowerMatchStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          play: true, //게임 진행 중인지
          step: 4,
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/event2/status',
      });

      return response;
    },
    /**
     * @description 꽃 맞히기 상태 조회
     */
    async fetchFlowerMatchStatus({ dispatch, commit }) {
      console.log('fetchFlowerMatchStatus');
      const flowerMatchStatus = await dispatch('getFlowerMatchStatus');

      commit('setFlowerMatchStatus', flowerMatchStatus);
      return;
    },
    /**
     * @description 꽃 맞히기 기록 조회
     */
    async getFlowerMatchRecord({ dispatch }) {
      if (IS_LOCAL) {
        return [
          {
            date: '2025-04-12T00:00:00',
            omc: 5,
            content: ['tulip', 'maylily', 'maylily', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
          {
            date: '2025-04-12T00:00:00',
            omc: 7,
            content: ['tulip', null],
          },
        ];
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/event2/history',
      });

      return response;
    },
    /**
     * @description 꽃 맞히기 기록 조회
     */
    async fetchFlowerMatchRecord({ dispatch, commit }) {
      console.log('fetchFlowerMatchRecord');
      const flowerMatchRecord = await dispatch('getFlowerMatchRecord');

      commit('setFlowerMatchRecord', flowerMatchRecord);
      return;
    },
    /**
     * @description 꽃 맞히기 GO
     */
    async postFlowerMatchGo({ dispatch }, { flower }) {
      if (IS_LOCAL) {
        // 틀림
        // return {
        //   result: false,
        //   answer: 'tulip',
        //   clearStep: 0, //clear한 단계
        //   completedGame: true, //게임 끝
        //   today: 2,
        //   omc: 4, // 획득 omc
        // };
        // 10단계 완성
        return {
          result: true,
          answer: 'tulip',
          clearStep: 10, //clear한 단계
          completedGame: true, //게임 끝
          today: 532,
          omc: 512, // 획득 omc
        };
        // 1~9 단계
        // return {
        //   result: true,
        //   answer: 'tulip',
        //   clearStep: 3, //clear한 단계
        //   completedGame: false, //게임 끝
        //   today: null,
        //   omc: 4, // 획득 omc
        // };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/event2/play',
        params: {
          flower: flower,
        },
      });

      return response;
    },
    /**
     * @description 꽃 맞히기 GO
     */
    async submitFlowerMatchGo({ dispatch }, { flower }) {
      console.log('submitFlowerMatchGo');
      const result = await dispatch('postFlowerMatchGo', { flower });

      return result;
    },
    /**
     * @description 꽃 맞히기 STOP
     */
    async postFlowerMatchStop({ dispatch }) {
      if (IS_LOCAL) {
        return {
          clearStep: 2, //clear한 단계
          today: 10,
          omc: 512, // 획득 포인트
        };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/event2/stop',
      });

      return response;
    },
    /**
     * @description 꽃 맞히기 STOP
     */
    async submitFlowerMatchStop({ dispatch }) {
      console.log('submitFlowerMatchStop');
      const result = await dispatch('postFlowerMatchStop');

      return result;
    },
  },
};

export default SpringStore;
